<template>
	<b-modal
		:hide-footer="true"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		:title="$t('Cadastrar')"
		centered
		id="add-item"
		no-fade
	>
		<template v-slot:default>
			<loading-animation
				:active.sync="loading"
				:is-full-page="false"
				:opacity="1"
				color="#5895FF"
			/>
			<form @submit.prevent="addItem" ref="addItem">
				<b-form-group class="mb-2" label-for="nome">
					<template v-slot:label
						>{{ $t("Nome") }} <span class="text-danger">*</span></template
					>
					<b-form-input id="nome" required v-model="item.nome" />
				</b-form-group>

				<div class="float-right mt-3">
					<router-link class="btn btn-danger" to="/dashboard/tiposunidade">
						<i class="mdi mdi-close" />
						{{ $t("Cancelar") }}
					</router-link>
					<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Salvar") }}
					</button>
				</div>
			</form>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: "Add",
	mounted() {
		this.$bvModal.show("add-item");
	},
	data() {
		return {
			loading: false,
			item: {
				nome: null,
			},
		};
	},
	methods: {
		// Add role
		addItem() {
			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			// Send request
			axios.post("api/dashboard/tipounidade/", this.item).then((response) => {
				ladda.stop();
				this.$snack.success({
					button: false,
					text: response.data.data.message,
				});
				this.$router.push("/dashboard/tiposunidade");
				this.$parent.getTipoUnidades();
			});
		},
	},
};
</script>
